<template>
  <div class="newsletter">
    <div class="top d-flex justify-content-between align-items-center">
      <transition name="slide-fade">
        <h1 class="mb-0">{{msg}}</h1>
      </transition>
      <el-button
        type="primary"
        size="medium"
        round
        v-b-modal.newsletterModal
        @click="newsletterForm = {}"
      >
        <i class="far fa-newspaper mr-1"></i>Nuevo boletín
      </el-button>
    </div>
    <el-alert class="mt-3" :title="desc" type="info" :closable="false"></el-alert>
    <el-tabs type="card" class="mt-3">
      <el-tab-pane>
        <span slot="label">
          <i class="far fa-file-alt text-muted mr-1"></i>Borrador
        </span>
        <el-table
          v-if="newslettersDraft.length > 0"
          class="mt-3"
          v-loading="loadingNewsletters"
          :data="newslettersDraft"
        >
          <el-table-column prop="id" label="ID" width="75px"></el-table-column>
          <el-table-column prop="title" label="Título"></el-table-column>
          <el-table-column label="Acción" align="right">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="small"
                v-b-modal.sendNewsModal
                @click="sendNewsletter(scope.row.id)"
              >
                <i class="far fa-paper-plane mr-1"></i>Enviar
              </el-button>
              <el-button type="info" size="small">
                <a class="text-white" :href="scope.row.url" target="_blank">
                  <i class="fas fa-search"></i>
                </a>
              </el-button>
              <el-button
                type="warning"
                size="small"
                v-b-modal.editNewsModal
                @click="editNewsletter(scope.row.id)"
              >
                <i class="fas fa-pencil-alt"></i>
              </el-button>
              <el-button
                type="danger"
                size="small"
                v-b-modal.deleteNewsModal
                @click="deleteNewsletter(scope.row.id)"
              >
                <i class="far fa-trash-alt"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-alert v-else class="mt-3" title="No hay borradores" type="info" :closable="false"></el-alert>
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label">
          <i class="far fa-paper-plane text-muted mr-1"></i>Enviados
        </span>
        <el-table class="mt-3" v-loading="loadingNewsletters" :data="newslettersSent">
          <el-table-column prop="id" label="ID" width="75px"></el-table-column>
          <el-table-column prop="title" label="Título"></el-table-column>
          <el-table-column label="Fecha">
            <template slot-scope="scope">{{ scope.row.sentDate | moment('DD/MM/YYYY HH:mm:ss') }}</template>
          </el-table-column>
          <el-table-column label="Acción" align="right">
            <template slot-scope="scope">
              <el-button type="info" size="small">
                <a class="text-white" :href="scope.row.url" target="_blank">
                  <i class="fas fa-search mr-1"></i>Ver boletín
                </a>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <b-modal
      ref="newsletterModalRef"
      id="newsletterModal"
      title="Crear nuevo boletín"
      @ok="saveNewsletter"
    >
      <form @submit.prevent="showModal = false">
        <b-form-group label="Título*">
          <b-form-input type="text" required v-model="newsletterForm.title"></b-form-input>
          <div class="invalid-feedback">El título es obligatorio</div>
        </b-form-group>
        <b-form-group label="Descripción*">
          <b-form-textarea v-model="newsletterForm.description"></b-form-textarea>
          <div class="invalid-feedback">La descripción es obligatoria</div>
        </b-form-group>
        <b-form-group label="URL*">
          <b-form-input type="text" required v-model="newsletterForm.url"></b-form-input>
          <div class="invalid-feedback">La URL del boletín es obligatoria</div>
        </b-form-group>
      </form>
    </b-modal>

    <b-modal ref="editNewsModalRef" id="editNewsModal" title="Editar boletín" @ok="patchNewsletter">
      <form @submit.prevent="showModal = false">
        <b-form-group label="Título*">
          <b-form-input type="text" required v-model="newsletterForm.title"></b-form-input>
          <div class="invalid-feedback">El título es obligatorio</div>
        </b-form-group>
        <b-form-group label="Descripción*">
          <b-form-textarea v-model="newsletterForm.description"></b-form-textarea>
          <div class="invalid-feedback">La descripción es obligatoria</div>
        </b-form-group>
        <b-form-group label="URL*">
          <b-form-input type="text" required v-model="newsletterForm.url"></b-form-input>
          <div class="invalid-feedback">La URL del boletín es obligatoria</div>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { APIENDPOINT } from "@/backend";

export default {
  name: "newsletter",

  data() {
    return {
      msg: "Newsletter",
      desc: "Gestión de los boletines",
      loadingNewsletters: false,
      newsletters: [],
      newsletterForm: { title: "", description: "", url: "" }
    };
  },

  mounted() {
    this.getNewsletters();
  },

  methods: {
    getNewsletters() {
      this.loadingNewsletters = true;

      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/newsletter"
      })
        .then(response => {
          this.loadingNewsletters = false;
          if (response.data.code === 0) {
            this.newsletters = response.data.data.newsletters;
            // console.group("newsletters:");
            // console.log(this.newsletters);
            // console.groupEnd();
          }
        })
        .catch(e => {
          this.errors.push(e);
        });
    },

    editNewsletter(id) {
      this.newsletterForm = this.newsletters.find(item => item.id === id);
    },

    patchNewsletter() {
      event.preventDefault();

      const duration = 2000;

      if (this.newsletterForm.title === "") {
        this.$message({
          showClose: false,
          message: "Título requerido",
          type: "error",
          duration: duration
        });
        return false;
      }

      if (this.newsletterForm.description === "") {
        this.$message({
          showClose: false,
          message: "Descripción requerida",
          type: "error",
          duration: duration
        });
        return false;
      }

      if (this.newsletterForm.url === "") {
        this.$message({
          showClose: false,
          message: "URL requerida",
          type: "error",
          duration: duration
        });
        return false;
      }

      this.loadingNewsDetails = true;
      let axiosData = {
        title: this.newsletterForm.title,
        description: this.newsletterForm.description,
        url: this.newsletterForm.url
      };
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "patch",
        url: "/api/v1/newsletter/" + this.newsletterForm.id,
        data: axiosData
      })
        .then(response => {
          // console.log(axiosData, response);
          this.loadingNewsDetails = false;
          if (response.data.code === 0) {
            this.newsletterForm = { title: "", description: "", url: "" };
            this.getNewsletters();
          }
        })
        .catch(e => {
          this.errors.push(e);
        });
    },

    saveNewsletter() {
      event.preventDefault();

      const duration = 2000;

      if (typeof this.newsletterForm.title === "undefined") {
        this.$message({
          showClose: false,
          message: "Título requerido",
          type: "error",
          duration: duration
        });
        return false;
      }

      if (typeof this.newsletterForm.description === "undefined") {
        this.$message({
          showClose: false,
          message: "Descripción requerida",
          type: "error",
          duration: duration
        });
        return false;
      }

      if (typeof this.newsletterForm.url === "undefined") {
        this.$message({
          showClose: false,
          message: "URL requerida",
          type: "error",
          duration: duration
        });
        return false;
      }

      this.loadingNewsDetails = true;
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "post",
        url: "/api/v1/newsletter",
        data: {
          title: this.newsletterForm.title,
          description: this.newsletterForm.description,
          url: this.newsletterForm.url
        }
      })
        .then(response => {
          console.log(response);
          this.loadingNewsDetails = false;
          if (response.data.code === 0) {
            this.newsletterForm = {};
            this.getNewsletters();
          }
        })
        .catch(e => {
          this.errors.push(e);
        });
    },

    sendNewsletter(id) {
      this.$confirm(
        "Seguro que quieres enviar el boletín ID " + id,
        "Atención",
        {
          confirmButtonText: "Enviar",
          cancelButtonText: "Cancelar",
          iconClass: "el-icon-question"
        }
      )
        .then(() => {
          this.loadingNewsletters = true;
          axios({
            baseURL: APIENDPOINT,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("token")).access_token
            },
            method: "patch",
            url: "/api/v1/newsletter/" + id,
            data: { sent: true }
          })
            .then(response => {
              this.loadingNewsletters = false;
              if (response.data.code === 0) {
                // console.group("send:");
                // console.log(response);
                // console.groupEnd();
                this.getNewsletters();
              }
            })
            .catch(e => {
              this.errors.push(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "warning",
            message: "Cancelado"
          });
        });
    },

    deleteNewsletter(id) {
      this.$confirm(
        "Seguro que quieres borrar el boletín ID " + id,
        "Atención",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          iconClass: "el-icon-question"
        }
      )
        .then(() => {
          this.loadingNewsletters = true;
          axios({
            baseURL: APIENDPOINT,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("token")).access_token
            },
            method: "delete",
            url: "/api/v1/newsletter/" + id
          })
            .then(response => {
              this.loadingNewsletters = false;
              if (response.data.code === 0) {
                console.group("delete:");
                console.log(response);
                console.groupEnd();
                this.getNewsletters();
              }
            })
            .catch(e => {
              this.errors.push(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "warning",
            message: "Cancelado"
          });
        });
    }
  },

  computed: {
    newslettersDraft() {
      return this.newsletters.filter(item => !item.sent);
    },

    newslettersSent() {
      return this.newsletters.filter(item => item.sent);
    }
  }
};
</script>